import * as Yup from 'yup';
import messages from './changePasswordForm.messages';
import { CHANGE_PASSWORD_FIELDS as FIELDS } from '../../../../modules/auth/auth.constants';

export const defaultValues = {
  [FIELDS.password]: '',
};

export const ChangePasswordSchema = Yup.object().shape({
  [FIELDS.password]: Yup.string().required(messages.fieldRequired),
});
